module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bg_f5f6f9"
  }), _vm._v(" "), _c('ul', {
    staticClass: "device-list"
  }, _vm._l((_vm.deviceList), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.listClick(item)
        }
      }
    }, [_c('dl', [_c('dt', [_c('img', {
      attrs: {
        "src": require('../../assets/img/device/icon_' + item.name + '.png')
      }
    })]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(item.chName))])])])
  })), _vm._v(" "), _c('save-img-base64', [_c('img', {
    attrs: {
      "src": require("../../assets/img/connect/bind_xiaofang.png"),
      "name": "bind_xiaofang"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/connect/bind_xiaoyuan.png"),
      "name": "bind_xiaoyuan"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/connect/bind_allonePro.png"),
      "name": "bind_allonePro"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/connect/bind_S20c.png"),
      "name": "bind_S20c"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/connect/bind_S30c.png"),
      "name": "bind_S30c"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/connect/bind_wifiLedStrip.png"),
      "name": "bind_wifiLedStrip"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/connect/connectStart_xiaofang.png"),
      "name": "connectStart_xiaofang"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/connect/connectStart_xiaoyuan.png"),
      "name": "connectStart_xiaoyuan"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/connect/connectStart_allonePro.png"),
      "name": "connectStart_allonePro"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/connect/connectStart_S20c.png"),
      "name": "connectStart_S20c"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/connect/connectStart_S30c.png"),
      "name": "connectStart_S30c"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/connect/connectStart_wifiLedStrip.png"),
      "name": "connectStart_wifiLedStrip"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/connect/reset_xiaofang.png"),
      "name": "reset_xiaofang"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/connect/reset_xiaoyuan.png"),
      "name": "reset_xiaoyuan"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/connect/reset_allonePro.png"),
      "name": "reset_allonePro"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/connect/reset_S20c.png"),
      "name": "reset_S20c"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/connect/reset_S30c.png"),
      "name": "reset_S30c"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/connect/reset_wifiLedStrip.png"),
      "name": "reset_wifiLedStrip"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/connect/network_set.png"),
      "name": "network_set"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/connect/phone_wifi.png"),
      "name": "phone_wifi"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/connect/tmall.png"),
      "name": "tmall"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-213fe012"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/connect/DeviceList.vue
// module id = 877
// module chunks = 1